import React from 'react';
import { List } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import fetch from '@/hooks/fetch';
import CollectionsLabelGroup from '@/collections/components/CollectionsLabelGroup';
import { fetchDatasetCollections } from '../actions';
import findDatasetCollectionEntities from '../helper';

const DatasetCollectionsList = ({
  category,
  code,
  collections,
  fetchData,
  readStatus,
}) => {
  fetch.useFetchByCode(fetchData, category, code, readStatus);
  if (!collections.length) {
    return null;
  }

  return (
    <List.Item className="aridhia-dataset-collections-list-item">
      <List.Header>
        <FormattedMessage id="dataset.collections.title" />
      </List.Header>
      <CollectionsLabelGroup collections={collections} className="mt-10" />
    </List.Item>
  );
};

const withoutItem = (item) => (
  {
    readStatus: item?.readStatus || states.NONE,
    readErrors: [],
    collections: [],
  }
);

const withItem = (datasetCollection, collections) => ({
  readStatus: datasetCollection.readStatus,
  collections: collections.results,
});

const mapStateToProps = ({
  datasetCollections: {
    datasetCollections,
  },
}, { category, code }) => {
  const item = findResult(datasetCollections, category, code);
  const collections = findDatasetCollectionEntities(datasetCollections, code);
  return (item?.readStatus === states.SUCCESS || item?.readStatus === states.ERROR)
    ? withItem(item, collections) : withoutItem(item);
};

const mapDispatchToProps = {
  fetchData: fetchDatasetCollections,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetCollectionsList);
